export default __webpack_public_path__ + "static/media/region_globe.a123665a.svg";